import React from 'react';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {Icon} from "@material-ui/core";
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import SettingsIcon from '@material-ui/icons/Settings';
import LockIcon from '@material-ui/icons/Lock';
import {gray} from "color-name";
import {PAYMENT_ROUTES} from "../config/routes";
import {getPaymentData} from "../services/authService";
import ChangeLabel from "./Popups/ChangeLabel";
import PaymentAmountPopup from "./Popups/PaymentAmountPopup";
export default function SimpleMenu(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [isOpenPaymentPopup, setIsOpenPaymentPopup] = React.useState(null);
    const disabledPayment = !props.userId;
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    const getPaymentUrl = () => {
        var button = window.$ipsp.get('button');
        button.setMerchantId(1458041);
        button.setAmount('', 'UAH');
        button.setResponseUrl(PAYMENT_ROUTES.returnUrl);
        button.setHost('api.fondy.eu');
        button.addField({
            label: 'UsrId',
            name: 'userId',
            value: props.user.id + '',
            'readonly':true
        });
        return button.getUrl();
    }

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{width: "80%"}}>
            <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}
                    style={{textTransform: 'none', width: '100%', display: "block", paddingLeft: 0}}>
                <span style={{display: 'inline-block', float: 'left'}}>{props.user.agency_name}</span>
                <div style={{display: 'inline-block', float: 'right'}}>
                    <ArrowDropDownIcon/>
                </div>
            </Button>

            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                style={{}}
            >
                {/*<MenuItem  style={{color: "gray", width: '100%', fontSize: '0.7rem', paddingBottom: '7%', paddingTop: '7%'}} onClick={() => {props.settingsFunc(); handleClose()}}><SettingsIcon />&nbsp;&nbsp;&nbsp;Настройка</MenuItem>*/}
                <MenuItem style={{color: "gray", width: '100%', fontSize: '0.7rem', paddingBottom: '7%'}}
                          onClick={props.changePassword}><LockIcon/> &nbsp;&nbsp;&nbsp;Смена пароля</MenuItem>
                <MenuItem style={{color: "gray", width: '100%', fontSize: '0.7rem', paddingBottom: '7%'}}
                          onClick={() => {
                              props.logoutFunc();
                              handleClose()
                          }}><ExitToAppIcon/> &nbsp;&nbsp;&nbsp;Выход</MenuItem>
            </Menu>

            <div>
                <span style={{color: 'gray'}}>Баланс: </span> <span style={{color: 'green'}}>
                {props.user.balance ? ((props.user.balance.ballance / 100) + ' ' + props.user.balance.currency) : (0 + ' UAH')}
            </span>
            </div>
            {/*<div>*/}
            {/*    <span style={{color: 'gray'}}>Бонус: </span> <span style={{color: 'green'}}>*/}
            {/*    {props.user.balance ? ((props.user.balance.bonus_ballance / 100) + ' ' + props.user.balance.currency) : (0 + ' UAH')}*/}
            {/*</span>*/}
            {/*</div>*/}
            
            <Button disabled={disabledPayment} onClick={ async () => {
                setIsOpenPaymentPopup(true)
                // const url = getPaymentUrl();
                // window.location.href = url;
            }} variant="contained" color="primary" style={{
                borderRadius: '50px',
                marginTop: '5%',
                marginBottom: '5%',
                fontSize: '0.7rem',
                width: '100%',
                color: '#fff'
            }}>
                Пополнить баланс
            </Button>
            <PaymentAmountPopup
                open={isOpenPaymentPopup}
                onClose={() => setIsOpenPaymentPopup(false)}
            />
        </div>
    );
}